/**
 * This is the default `FxLayoutGap`
 */
export const FX_LAYOUT_GAP = '1rem';
